const legalShieldSrc = "/images/legalshield-logo.png";

export const LegalShieldCard = () => {
  return (
    <div className="border border-[#e0e0e0] rounded-2xl p-8 max-w-4xl mx-auto">
      <div className="flex justify-between items-start pb-4 border-b border-[#d0d0d0] mb-4">
        <div>
          <h2 className="text-3xl font-bold text-black mb-2">LegalShield Member</h2>
          <div className="text-base text-black">
            Access legal services and member benefits.
          </div>
        </div>
        <div className="text-right">
          <img src={legalShieldSrc} alt="LegalShield" className="h-10" />
        </div>
      </div>

      <div className="text-sm text-gray-600">
        Present this ID when contacting LegalShield services.
      </div>
    </div>
  );
};


